import type { SocialLink } from '@/types/content'

export const site = {
  name: 'Alex Trinh',
  role: 'Mechanical Engineer',
  location: 'University of Waterloo',
  tagline: 'Mechanical engineering student building hardware that ships.',
  /** Phrases cycled by the typewriter on the landing page. */
  heroPhrases: [
    'Alex Trinh',
    'a mechanical engineer.',
    'a CAD enthusiast.',
    'a hardware tinkerer.',
    'a robotics enthusiast.',
  ],
  intro:
    "I'm a mechanical engineering student at the University of Waterloo, drawn to hard engineering problems and design on physical systems.",
  /**
   * Availability notice, shown as a status pill on the landing page and on the
   * contact page. Set to `null` to hide it everywhere.
   */
  availability: 'Open to New Grad opportunities for 2027',
  email: 'alexkltrinh@outlook.com',
} as const

export const navigation = [
  { label: 'Work', to: '/projects' },
  { label: 'About', to: '/about' },
  { label: 'Contact', to: '/contact' },
] as const

export const socials: SocialLink[] = [
  {
    label: 'Email',
    detail: site.email,
    href: `mailto:${site.email}`,
    icon: '/assets/icon-mail.png',
  },
  {
    label: 'GitHub',
    detail: '@alexkltrinh',
    href: 'https://github.com/alexkltrinh',
    icon: '/assets/icon-github.png',
  },
  {
    label: 'LinkedIn',
    detail: 'in/alexkltrinh',
    href: 'https://www.linkedin.com/in/alexkltrinh',
    icon: '/assets/icon-linkedin.png',
  },
]
